// extracted by mini-css-extract-plugin
export default {"groupName":"UserModal_groupName__VnCqk","roleTypeSelector":"UserModal_roleTypeSelector__6JxbK"};